import CardDefault from "ui/components/Cards/CardDefault";
import { Flex, Divider } from "@chakra-ui/react";
import CardPerson from "ui/components/Cards/CardPerson";
import ContentItem from "components/ContentItem/ContentItem";
import moment from "moment";
import TagStatusCobrancaPor from "./components/TagStatusCobrancaPor";
import TagStatusCard from "./components/TagStatusCard";
import { GoAlert } from "react-icons/go";
import { formatMoney } from "infra/helpers/number";
import { CobrancaItem } from "features/cobranca/typings";
import history from "infra/helpers/history";

interface CardStatusCobrancaProps {
  item: CobrancaItem;
  colorStatus: string;
}

export default function CardStatusCobranca({
  item,
  colorStatus,
}: CardStatusCobrancaProps) {
  return (
    <CardDefault
      rounded={10}
      mb={2}
      px={2}
      py={0}
      borderLeft={`solid 10px ${colorStatus}`}
      onClick={() => history.push(`/financeiro/receita/cobranca/${item.id}`)}
    >
      <Flex my={4}>
        <CardPerson
          alingAvatar="start"
          fontSizeName="13px"
          fontSizeSubtitle="11.5px"
          avatarProps={{ opacity: 1 }}
          avatarUrl={item.pessoa?.imagemUrl?.trim() || ""}
          nome={item.pessoa?.nome?.trim() || ""}
          subtitle={`${item?.numero?.trim() || ""} ${item?.blocoQuadra ? `, ${item?.blocoQuadra?.trim()}` : ""
            } `}
          childrenSubtitle={
            item.tipoContatoAcordo ? (
              <TagStatusCobrancaPor status={item.tipoContatoAcordo} />
            ) : null
          }
          border="1px solid gray"
        />

      </Flex>

      <Divider />
      <Flex my={1} flexDir="column">
        <Flex justifyContent="space-between">
          {item?.dataUltimaCobranca ? (
            <ContentItem
              titulo="Ultima cobrança em:"
              descricao={
                moment(item?.dataUltimaCobranca).format("DD/MM/YYYY, H:m") ||
                "--"
              }
            />
          ) : null}
          {item?.novoContato ? (
            <ContentItem
              titulo="Novo contato:"
              descricao={
                moment(item?.novoContato).format("DD/MM/YYYY, H:m") || "--"
              }
            />
          ) : null}
        </Flex>
        {item?.responsavel ? (
          <ContentItem
            mb="0"
            titulo="Responsável:"
            descricao={item?.responsavel?.nome || "--"}
          />
        ) : null}
      </Flex>
      <Flex mb={1} gap={1} alignItems="center" flexWrap="wrap">
        <TagStatusCard
          title={`${item?.diasEmAtraso} ${item?.diasEmAtraso ? "dias" : "dia"
            }\nem
              atraso`}
          icon={<GoAlert size={13} />}
          colorScheme={"red"}
        />

        {item.atrasoAcordo ? (
          <Flex alignItems="center">
            <TagStatusCard
              title={`Acordo`}
              icon={<GoAlert size={13} />}
              colorScheme={"red"}
            />
          </Flex>
        ) : null}

        <TagStatusCard
          colorScheme="gray"
          title={
            item?.totalDividas > 1
              ? `${item?.totalDividas} dividas`
              : `${item?.totalDividas} divida`
          }
        />
      </Flex>

      <Flex fontWeight="bold" fontSize="14px" ml="auto" mb={2}>
        {formatMoney(item?.valor)}
      </Flex>
    </CardDefault>
  );
}
